import React from 'react'
import _ from 'lodash'
import Header from './Header'
import moment from 'moment'
import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'
import { hashHistory } from 'react-router'
import DashboardChartComponent from './DashboardChartComponent'
import DashboardTextComponent from './DashboardTextComponent'
import store from '../Commons/store'
import { planesFunction } from './planesAction'

export default class PatientDashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({
      data: {
        patientImage: '',
        patientData: {},
        patientFullName: '',
        patientIdentification: '',
        patientAge: '',
        medicalData: {},
        medicalPAParado: '',
        medicalPASentado: '',
        medicalPAPA: '',
        medicalPAPB: '',
        medicalPASA: '',
        medicalPASB: '',
        medicalFrecuenciaC: '',
        medicalBalanceNeur: '',
        medicalFuma: '',
        medicalPeso: '',
        medicalBMIData: '',
        medicalColTotal: '',
        medicalColLDL: '',
        medicalColHDL: '',
        medicalColTrigliceridos: '',
        medicalCreatinina: '',
        medicalCol: '',
        chart1: [0, 0, 0, 0, 0],
        chart2: [0, 0, 0, 0, 0],
        percent_lost_capacity: 0,
        fx_reserve: 0,
        vitalityIndex: 0,
        functionalIndex: 0,
        arterialAge: 0,
        biologicalAge: 0,
        plan: '',
        img: ''
      },
      reservaFuncionalText: '',
      fxarterial: '',
      fxmetabolica: '',
      fxcardiopulmonar: '',
      afectivoBienestar: '',
      vigorBN: '',
      riesgosOcultos: '',
      cardiorespiratoria: '',
      indiceSatisfaccion: '',
      balanceAfectivo: '',
      vigorFS: '',
      balanceA: '',
      satif: '',
      redFamiliar: '', trabajoAgradable: '', pensionado: '',
      autonomia: '', redSocial: '', oportunidades: '', tiempolibre: '', proyectos: '',
      acumuladorSocial: 0,
      socClass: 'health-square left-square-printable',
      biologicalAgeResult: '',
      arterialAgeResult: '',
      planes: []
    })
    document.body.style.color = 'black'
    document.body.style.height = '100%'
    document.body.style.overflowX = 'hidden'
    document.body.style.background = 'white'
    try {
      function processFilter(arr) {
        if (typeof arr === 'object')
          return arr.filter((e, i) => { if (i === 0) return e })
        else
          return 'Sin plan de cuidado'
      }


      store.subscribe(() => {
        this.setState({
          planes: store.getState()
        })
      })
    } catch (e) {
      console.log(e)
    }

  }

  componentWillMount() {
    this.findPatientDashboard()
    planesFunction(this.props.params.patient)
  }

  findPatientDashboard() {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/patient/find?numeroDocumento=' + identificacion)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err, 'And respo: ', res)
        } else {
          let result = res.body[0]

          var birthday = new Date(result.fechaNacimiento.split('/').reverse().join('-'))
          var ageDifMs = Date.now() - birthday.getTime()
          var ageDate = new Date(ageDifMs)
          var age = Math.abs(ageDate.getUTCFullYear() - 1970)

          var newData = this.state.data
          newData.patientImage = result.image
          newData.patientFullName = result.nombres + ' ' + result.apellidos
          newData.patientIdentification = result.tipoDocumento + ' ' + result.numeroDocumento
          newData.patientAge = age
          newData.patientData = result
          this.setState({
            data: newData
          })
          this.findMedicalPatient(result._id)
        }
      })
  }

  squaresComponent() {
    request
      .get('api/v1/square/findSquareById?id=' + this.props.params.patient)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log(err)
        }
        if (res.status === 201) {
          let model = res.body[0]
          this.setState({
            /* Estado mental */
            proyectos: model.presentes,
            /* Estado social */
            redFamiliar: model.redFamiliar, trabajoAgradable: model.trabajoAgradable, pensionado: model.pensionado,
            autonomia: model.autonomia, redSocial: model.redSocial, oportunidades: model.oportunidades
          })
          this.estadoSocialClass()
        }
      })
  }

  estadoSocialClass() {
    if (this.state.redFamiliar === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.redFamiliar === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.trabajoAgradable === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.trabajoAgradable === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.pensionado === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.pensionado === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.autonomia === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.autonomia === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.redSocial === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.redSocial === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.oportunidades === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.oportunidades === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.acumuladorSocial >= 4) {
      this.setState({ socClass: 'health-square-bad-printable left-square-printable' })
    }
  }

  medicalDataCapture(e) {
    e.preventDefault()
    let age = this.state.data.patientAge
    let url = 'medical/' + this.props.params.patient
    console.log(age)
    if (age < 30 || age > 80) {
      this.refs.container.warning('Paciente con un rango de edad donde los cálculos no son exactos', '', {
        closeButton: true
      })
      setTimeout(() => { hashHistory.push(url) }, 3600)
    } else {
      hashHistory.push(url)
    }
  }

  findMedicalPatient(id) {
    request
      .get(`api/v1/estadoSalud/paciente/${id}/ultimoEstadoSalud/relations=[paciente]`)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err)
        } else {
          let medicalInfo = res.body
          let altura = medicalInfo.altura / 100
          let peso = medicalInfo.peso
          let indiceMasaC = Math.floor(peso / (altura * altura))
          var newData = this.state.data
          newData.allobj = res.body
          newData.medicalData = medicalInfo
          newData.medicalPAPA = medicalInfo.sistoleParado
          newData.medicalPAPB = medicalInfo.diastoleParado
          newData.medicalPASA = medicalInfo.sistoleSentado
          newData.medicalPASB = medicalInfo.diastoleSentado
          newData.medicalPAParado = newData.medicalPAPA + ' / ' + newData.medicalPAPB
          newData.medicalPASentado = newData.medicalPASA + ' / ' + newData.medicalPASB
          newData.medicalFrecuenciaC = medicalInfo.frecuencia
          newData.medicalBalanceNeur = medicalInfo.balanceNeuroMuscularT
          newData.medicalPeso = medicalInfo.peso
          newData.medicalFuma = medicalInfo.fuma
          newData.medicalBMIData = indiceMasaC
          // newData.medicalColTotal = medicalInfo.colesterolTotal + ' mg/dL'
          // newData.medicalColLDL = medicalInfo.colesterolLDL + ' mg/dL'
          // newData.medicalColHDL = medicalInfo.colesterolHDL + ' mg/dL'
          // newData.medicalColTrigliceridos = medicalInfo.trigliceridos + ' mg/dL'
          // newData.medicalCreatinina = medicalInfo.creatinina + ' mg/dL'
          // newData.medicalColGlicemia = medicalInfo.glicemia + ' mg/dL'

          this.setState({
            data: newData
          })
          
        }
        this.medicalCalculate(id)
        this.reservaFuncional()
        this.capacidadFuncional()
        this.indiceVitalidad()
        this.squaresComponent()
      })
  }

  medicalCalculate(patientId) {
    request
    .get(`api/v1/estadoSaludCalculado/ultimoEstadoDeSalud/${patientId}/`)
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err || !res.ok) {
        console.log('Error: ', err)
      } else {
        let calculate_ = res.body
        let healthRate = (this.state.data.medicalData.frecuencia < 30) ? 30 : (this.state.data.medicalData.frecuencia > 90) ? 90 : this.state.data.medicalData.frecuencia
        let timeFiveMe = this.state.data.medicalData.tiempoCincoM
        // let balanceNeu = this.state.data.medicalData.balanceNeuroMuscular
        let ArrayBalance =  [this.state.data.medicalData.balanceNeuroMuscularIzquierdo, this.state.data.medicalData.balanceNeuroMuscularDerecho]
        let balanceNeu = ArrayBalance.reduce((max, val) =>{ return Math.max(max,val)},ArrayBalance[0])
        balanceNeu = (balanceNeu < 10) ? 10 : (balanceNeu > 42) ? 42 : balanceNeu
        let cardioResp = this.state.data.medicalData.mets
        let transcendence = this.state.data.medicalData.depresion
        let satisfaccion = this.state.data.medicalData.satisfaccion
        let felicidad = this.state.data.medicalData.feliz
        let preocupado = this.state.data.medicalData.preocupacion
        let depresion = this.state.data.medicalData.decaido
        let gender = this.state.data.patientData.genero
        let peso = (this.state.data.medicalData.peso < 50) ? 50 : (this.state.data.medicalData.peso > 110) ? 110 : this.state.data.medicalData.peso
        let altura = this.state.data.medicalData.altura
        let birthday = moment(this.state.data.patientData.fechaNacimiento).format('DD/MM/YYYY')
        let smoke = this.state.data.medicalData.fuma
        let movility = this.state.data.medicalData.movilidad
        let personalCare = this.state.data.medicalData.cuidadoPersonal
        let dActivities = this.state.data.medicalData.actividadesCotidianas
        let patientPain = this.state.data.medicalData.dolor
        let anxiety = this.state.data.medicalData.ansiedad

        // let calculos = calculate(healthRate, timeFiveMe, balanceNeu, cardioResp, transcendence, satisfaccion, felicidad, preocupado, depresion,
        //   gender, peso, altura, birthday, smoke, movility, personalCare, dActivities, patientPain, anxiety)

        var newData = this.state.data
        newData.chart1 = [calculate_.reservaFuncional.perdidaCapacidadFuncional,calculate_.reservaFuncional.capacidadFuncional]
        newData.chart2 = [calculate_.indiceDeReservaFuncional.fxArterial, 
      calculate_.indiceDeReservaFuncional.fxMetabolica, 
      calculate_.indiceDeReservaFuncional.fxCardioPulmonar,
      calculate_.indiceDeReservaFuncional.balanceAfectivoYBienestar,
      calculate_.indiceDeReservaFuncional.vigorNeuromuscular]
      
      // newData.chart2 = calculos[1]
        // newData.chart2 = calculos[1]
        // newData.vitalityIndex = calculos[2]
        newData.percent_lost_capacity = calculate_.reservaFuncional.perdidaCapacidadFuncional
        newData.fx_reserve = calculate_.reservaFuncional.capacidadFuncional
        newData.arterialAge = calculate_.edadArterial
        newData.biologicalAge = calculate_.edadBiologica
       
        let {chart2} = newData
        const average = list => list.reduce((prev, curr) => prev + curr) / list.length;
        newData.functionalIndex = average(chart2)
        var difEdadBiologica = this.state.data.biologicalAge - this.state.data.patientAge
        if ((difEdadBiologica > 1) && (difEdadBiologica < 6)) {
          this.setState({ biologicalAgeResult: 'apropiada' })
        } else if (difEdadBiologica >= 6) {
          this.setState({ biologicalAgeResult: 'mala' })
        } else if (this.state.data.biologicalAge <= this.state.data.patientAge) {
          this.setState({ biologicalAgeResult: 'excelente' })
        }

        var difEdadArterial = this.state.data.arterialAge - this.state.data.patientAge
        if ((difEdadArterial > 1) && (difEdadArterial < 6)) {
          this.setState({ arterialAgeResult: 'apropiada' })
        } else if (difEdadArterial >= 6) {
          this.setState({ arterialAgeResult: 'mala' })
        } else if (this.state.data.arterialAge <= this.state.data.patientAge) {
          this.setState({ arterialAgeResult: 'excelente' })
        }

        this.setState({
          data: newData
        })

      }
    })
    
  }

  reservaFuncional() {
    let reserva = this.state.data.fx_reserve.toFixed(1)
    let edadPct = this.state.data.patientAge
    let generoP = this.state.data.patientData.genero

    if (generoP === 'f') {
      if (edadPct < 45) {
        if (reserva >= 80) {
          this.setState({ reservaFuncionalText: 'excelente' })
        } else if ((reserva < 80) && (reserva >= 60)) {
          this.setState({ reservaFuncionalText: 'regular' })
        } else if (reserva < 60) {
          this.setState({ reservaFuncionalText: 'mala' })
        }
      } else if ((edadPct > 45) && (edadPct < 65)) {
        if (reserva >= 75) {
          this.setState({ reservaFuncionalText: 'excelente' })
        } else if ((reserva < 75) && (reserva >= 50)) {
          this.setState({ reservaFuncionalText: 'regular' })
        } else if (reserva < 50) {
          this.setState({ reservaFuncionalText: 'mala' })
        }
      } else if (edadPct >= 65) {
        if (reserva >= 65) {
          this.setState({ reservaFuncionalText: 'excelente' })
        } else if ((reserva < 65) && (reserva >= 40)) {
          this.setState({ reservaFuncionalText: 'regular' })
        } else if (reserva < 40) {
          this.setState({ reservaFuncionalText: 'mala' })
        }
      }
    }

    if (generoP === 'm') {
      if (edadPct < 40) {
        if (reserva >= 82) {
          this.setState({ reservaFuncionalText: 'excelente' })
        } else if ((reserva < 82) && (reserva >= 60)) {
          this.setState({ reservaFuncionalText: 'regular' })
        } else if (reserva < 60) {
          this.setState({ reservaFuncionalText: 'mala' })
        }
      } else if ((edadPct > 40) && (edadPct <= 60)) {
        if (reserva >= 75) {
          this.setState({ reservaFuncionalText: 'excelente' })
        } else if ((reserva < 75) && (reserva >= 50)) {
          this.setState({ reservaFuncionalText: 'regular' })
        } else if (reserva < 50) {
          this.setState({ reservaFuncionalText: 'mala' })
        }
      } else if (edadPct > 60) {
        if (reserva >= 72) {
          this.setState({ reservaFuncionalText: 'excelente' })
        } else if ((reserva < 72) && (reserva >= 40)) {
          this.setState({ reservaFuncionalText: 'regular' })
        } else if (reserva < 40) {
          this.setState({ reservaFuncionalText: 'mala' })
        }
      }
    }
  }

  capacidadFuncional() {
    let FA = this.state.data.chart2[0]
    let FM = this.state.data.chart2[1]
    let FC = this.state.data.chart2[2]
    let BAB = this.state.data.chart2[3]
    let VBN = this.state.data.chart2[4]

    if (FA >= 8) {
      this.setState({ fxarterial: 'excelente' })
    } else if (FA < 8) {
      this.setState({ fxarterial: 'regular' })
    }

    if (FM >= 8) {
      this.setState({ fxmetabolica: 'excelente' })
    } else if (FM < 8) {
      this.setState({ fxmetabolica: 'regular' })
    }

    if (FC >= 8) {
      this.setState({ fxcardiopulmonar: 'excelente' })
    } else if (FC < 8) {
      this.setState({ fxcardiopulmonar: 'regular' })
    }

    if (BAB >= 8) {
      this.setState({ afectivoBienestar: 'excelente' })
    } else if (BAB < 8) {
      this.setState({ afectivoBienestar: 'regular' })
    }

    if (VBN >= 8) {
      this.setState({ vigorBN: 'excelente' })
    } else if (VBN < 8) {
      this.setState({ vigorBN: 'regular' })
    }
  }

  indiceVitalidad() {
    let RS = this.state.data.chart1[0]
    let VF = this.state.data.chart1[1]
    let CC = this.state.data.chart1[2]
    let BA = this.state.data.chart1[3]
    let ST = this.state.data.chart1[4]

    if (RS >= 7) {
      this.setState({ riesgosOcultos: 'excelente' })
    } else if (RS < 7) {
      this.setState({ riesgosOcultos: 'regular' })
    }

    if (CC >= 7) {
      this.setState({ cardiorespiratoria: 'excelente' })
    } else if (CC < 7) {
      this.setState({ cardiorespiratoria: 'regular' })
    }

    if (ST >= 7) {
      this.setState({ indiceSatisfaccion: 'excelente' })
    } else if (ST < 7) {
      this.setState({ indiceSatisfaccion: 'regular' })
    }

    if (BA >= 7) {
      this.setState({ balanceAfectivo: 'excelente' })
    } else if (BA < 7) {
      this.setState({ balanceAfectivo: 'regular' })
    }

    if (VF >= 7) {
      this.setState({ vigorFS: 'excelente' })
    } else if (VF < 7) {
      this.setState({ vigorFS: 'regular' })
    }

    this.setState({ satif: ST, balanceA: BA })
  }

  printReport(e) {
    e.preventDefault()
    // var url = "http://sicorresultados.integ.ro:9990/print_result_core3"
    // url = "http://localhost:9990/print_result_core3"
    var url = "https://htmltopdf.sicor.com.co/print_result_core3"
    let date = moment().format('YYYYMMDD')
    let name = `${this.props.params.patient}-${date}-core3`
    var send = () => {
      request
        .post(url)
        // .set("Authorization", "Bearer " + getToken())

        .send({
          html: `<!DOCTYPE html> <html> <head> <meta charset="UTF-8"> <title>Informe paciente</title> <link rel="stylesheet" href="print.css"></link> </head> <body>${document.body.innerHTML} </body></html>`,
          name: name + ".html",
          date: date,
          apiName: name,
          id: this.props.params.patient
        }).set("Accept", "application/json")
        .end((err, res) => {

          console.log(res)
          window.print()
        })
    }
    var myChart = document.getElementById('myChart')
    var other = document.getElementById('uniqueRadar')
    myChart = myChart.toDataURL()
    other = other.toDataURL()
    this.setState({ img: myChart, img2: other }, () => {
      setTimeout(() => {
        document.getElementById('myChart').remove()
        document.getElementById('uniqueRadar').remove()
        setTimeout(() => { send() }, 900)
      }, 900)
    })

  }

  render() {
    document.title = 'Dashboard Paciente - CORE 3.0'
    return (
      <div className='dashboard-container-printable'>
        <Header data={this.state.data} />
        <hr />
        <div className='someText-body someText-intro'>
          <p>En <strong className='blue'>SICOR</strong> nos hemos concentrado en cuidar la salud de una persona en forma integral. Creemos en la afirmación: <strong className='blue'>“la salud no lo es todo, pero sin ella todo lo demás es nada”. </strong>
            y, por eso, buscamos que su estado de salud sea siempre óptimo.</p>
          <p>Todos quisiéramos vivir al máximo de nuestra capacidad y esta capacidad máxima es la reserva funcional, la cual se va perdiendo con los años sin darnos cuenta. Para funcionar bien en nuestra vida diaria, esta reserva debe estar cercana al 70%. Para evaluarla medimos cinco componentes en su organismo que deben estar en 10 puntos y así sabremos si su organismo es mas viejo por dentro en relación con sus años de vida cronológica, esto es, la edad biológica. También medimos su edad arterial para saber el grado de deterioro de sus arterias. Su edad arterial o biológica óptimas no debe ser mayores de 6 años que su edad cronológica y lo ideal sería tenerlas iguales.</p>
          <p><b>A continuación encontrará los resultados de su evaluación:</b></p>
        </div>
        <div className='dashboard-charts-components-printable'>
          <DashboardChartComponent img2={this.state.img2} img={this.state.img} data={this.state.data} propiedades={this.state} />
          <DashboardTextComponent key={`${moment().format('x')}${Math.random()}`} propiedades={this.state} plan={this.state.planes} />
          <div className='chart-section-printable'>
            <div ref='print-button' className='print-button' onClick={this.printReport.bind(this)}>Imprimir Reporte</div>
          </div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
PatientDashboard.propTypes = {
  params: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/DashboardComponent.js